import { useMemo } from 'react';

import { useAuthSession } from 'hooks/useAuthSession';

import { UserPermissions, UserRoleFlags } from 'models/user.model';

const useRoleFlags = (): UserRoleFlags => {
    const { user, status } = useAuthSession();

    const permissions = useMemo<UserPermissions[]>(() => {
        return user?.permissions || [];
    }, [user]);

    const isReadUser = useMemo<boolean>(() => {
        return (
            permissions.length === 1 &&
            permissions.includes(UserPermissions.READ)
        );
    }, [permissions]);

    const hasDeleteAccess = useMemo(() => {
        return permissions.includes(UserPermissions.DELETE);
    }, [permissions]);

    const isAdmin = useMemo<boolean>(() => {
        return permissions.includes(UserPermissions.ADMIN);
    }, [permissions]);

    const hasWriteAccess = useMemo<boolean>(() => {
        return (
            permissions.includes(UserPermissions.WRITE) ||
            permissions.includes(UserPermissions.ADMIN)
        );
    }, [permissions]);

    const hasCreateFormulaAccess = useMemo(() => {
        return (
            permissions.includes(UserPermissions.CREATE_FORMULA) ||
            permissions.includes(UserPermissions.CREATE)
        );
    }, [permissions]);

    return {
        isReadUser,
        isAdmin,
        hasWriteAccess,
        status,
        hasDeleteAccess,
        hasCreateFormulaAccess,
    };
};

export default useRoleFlags;
